import React, { useState } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import { FBQ_EVENTS } from '../../constants';
import {
    Contact,
    ContactLink,
    ContactLinkDivider,
    ContactLinks,
    ContactTitle,
    Contacts,
    Icon,
    Image,
    Item,
    Title,
    Wrapper,
} from './Hero.elements';

export interface HeroProps {}

const HeroTemplate: FC<HeroProps> = () => {
    const { t } = useTranslations();

    return (
        <Wrapper>
            <Image src={publicAssets('/contact_hero.webp')} />
            <Contacts>
                <Title>{t('contact.hero.title')}</Title>
                <Item>
                    <Icon name={Icons.Call} />
                    <Contact>
                        <ContactTitle>{t('contact.orders.title')}</ContactTitle>
                        <ContactLinks>
                            <ContactLink
                                onClick={() => (window as any)?.fbq?.('track', FBQ_EVENTS.CONTACT)}
                                href={`tel:${t('contact.service.tel')}`}
                            >
                                {t('contact.orders.tel')}
                            </ContactLink>
                            <ContactLinkDivider />
                            <ContactLink
                                onClick={() => (window as any)?.fbq?.('track', FBQ_EVENTS.CONTACT)}
                                href={`mailto:${t('contact.orders.mail')}`}
                                className="primary"
                            >
                                {t('contact.orders.mail')}
                            </ContactLink>
                        </ContactLinks>
                    </Contact>
                </Item>
                <Item>
                    <Icon name={Icons.Service} />
                    <Contact>
                        <ContactTitle>{t('contact.services.title')}</ContactTitle>
                        <ContactLinks>
                            <ContactLink
                                onClick={() => (window as any)?.fbq?.('track', FBQ_EVENTS.CONTACT)}
                                href={`tel:${t('contact.services.tel1')}`}
                            >
                                {t('contact.services.tel1')}
                            </ContactLink>
                            <ContactLinkDivider />
                            <ContactLink
                                onClick={() => (window as any)?.fbq?.('track', FBQ_EVENTS.CONTACT)}
                                href={`tel:${t('contact.services.tel2')}`}
                            >
                                {t('contact.services.tel2')}
                            </ContactLink>
                        </ContactLinks>
                    </Contact>
                </Item>
            </Contacts>
        </Wrapper>
    );
};

export default HeroTemplate;
